import type { BaseEntity } from './BaseEntity';

export enum ConsumableLineItemUseType {
  YEARLY = 'YEARLY',
  BATCH = 'BATCH',
}

export interface ConsumableLineItem extends BaseEntity {
  description: string;
  consumableLineItemUseType: ConsumableLineItemUseType;
  orderQuantity: number;
  unitQuantity: number;
  batchQuantity?: number;
  unitCost: number;
  shippingCost?: number;
  totalQuantity?: number;
  subtotalCost?: number;
  unitTax?: number;
  totalCost?: number;
  totalUnitCost?: number;
  totalBatchCost?: number;
  taxRate?: number;
}

type ValidationResult = { issues: { message: string; path: (keyof ConsumableLineItem)[] }[] };

export function validate(consumableLineItem: Partial<ConsumableLineItem>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!consumableLineItem.description) {
    issues = [...issues, { message: 'Description is required', path: ['description'] }];
  }

  if (!consumableLineItem.consumableLineItemUseType) {
    issues = [...issues, { message: 'Consumable line item use type is required', path: ['consumableLineItemUseType'] }];
  }

  if (!consumableLineItem.orderQuantity) {
    issues = [...issues, { message: 'Order quantity is required', path: ['orderQuantity'] }];
  }

  if (!consumableLineItem.unitQuantity) {
    issues = [...issues, { message: 'Unit quantity is required', path: ['unitQuantity'] }];
  }

  if (!consumableLineItem.unitCost) {
    issues = [...issues, { message: 'Unit cost is required', path: ['unitCost'] }];
  }

  return { issues };
}